import { Coordinates } from '../../../modules/stores/types';

export const getDirectionLink = (origin: Coordinates, destination: Coordinates) => {
  return `https://www.google.com/maps/dir/?api=1&origin=${origin.lat},${origin.lng}&destination=${destination.lat},${destination.lng}&travelmode=driving`;
};
